export default {
    error: null,
}
